import { Media } from 'assets/Mixins.style';
import { HashLink as RouterLink } from 'react-router-hash-link';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: ${props => props.theme.margin.default};

  ${Media.lg`
    margin: ${props => props.theme.margin.lg};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
  `}

  ${Media.sm`
    margin: ${props => props.theme.margin.sm};
  `}
`;
export const Link = styled.span`
  display: block;
  position: ${props => props.theme.position || 'static'};
  width: auto;
  top: 0;
  transform: ${props => props.theme.transform || '0'};
  right: -34px;
  padding: ${props => props.theme.padding || '0'};
  background-color: ${props => props.theme.backgroundColor || 'transparent'};
  transition: 0.2s all;
  color: ${props =>
    props.firstReadMoreLinkColor ||
    props.readMoreLinkColor ||
    props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  background-color: ${props => props.theme.backgroundColor};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  &:hover {
    color: ${props => props.theme.backgroundColorOnHover || props.theme.color};
  }
  ${props =>
    props.main &&
    css`
      color: ${props =>
        props.firstReadMoreLinkColor ||
        props.readMoreLinkColor ||
        props.theme.main.color ||
        props.theme.color};
      background-color: ${props => props.theme.main.backgroundColor};
      padding: ${props => props.theme.main.padding};
      border-radius: ${props => props.theme.main.borderRadius};
      top: 60px;
      font-size: ${props => `${props.theme.main.fontSize.default}rem`};
      transform: ${props => props.theme.main.transform || '0'};
      ${Media.lg`
        font-size: ${props => `${props.theme.main.fontSize.lg}rem`};
        transform: ${props => props.theme.main.transformLg || '0'};

      `}

      ${Media.md`
        font-size: ${props => `${props.theme.main.fontSize.md}rem`};
      `}

      ${Media.sm`
        font-size: ${props => `${props.theme.main.fontSize.sm}rem`};
      `}
      &:hover {
        color: ${props => props.theme.main.colorOnHover};
      }
    `};
`;

export const Box = styled.div`
  display: grid;
  width: 100%;
  column-gap: ${props => props.theme.columnGap.default};
  row-gap: ${props => props.theme.rowGap.default};
  align-items: ${props => props.theme.alignItems};
  grid-template-columns:  ${props => props.theme.gridTemplateColumns.default};
  padding: ${props => props.theme.padding.default};
  border-top: 1px solid ${props => props.theme.border};
  border-bottom: 1px solid ${props => props.theme.border};
  div:first-child {
    grid-area: 1/3/2/5;
    margin:0;
    ${Media.lg`
    grid-area: 1/1/2/3;
  `}
  ${Media.sm`
    grid-area: 1/1/2/2;
    `}
  }
  ${props =>
    props.reverted &&
    css`
      div:first-child {
        grid-area: 1/1/2/3;
        ${Media.lg`
          grid-area: 1/1/2/3;
          `}
        ${Media.sm`
          grid-area: 1/1/2/2;
        `}
      }
    `}
  ${Media.lg`
    grid-template-columns:  ${props => props.theme.gridTemplateColumns.lg};
    column-gap: ${props => props.theme.columnGap.default};
    row-gap: ${props => props.theme.rowGap.default};
  `}

  ${Media.md`
    grid-template-columns:  ${props => props.theme.gridTemplateColumns.md};
    column-gap: ${props => props.theme.columnGap.default};
    row-gap: ${props => props.theme.rowGap.default};
    padding: ${props => props.theme.padding.md};
  `}

  ${Media.sm`
    grid-template-columns:  ${props => props.theme.gridTemplateColumns.sm};
    column-gap: ${props => props.theme.columnGap.default};
    row-gap: ${props => props.theme.rowGap.default};
  `}
`;

export const ItemHolder = styled.div`
  position: relative;
  display: block;
  width: 100%;
  ${props =>
    props.main &&
    css`
      grid-area: ${props => ` ${props.theme.main.gridArea.default} !important`};
      margin: ${props => props.theme.main.margin.default};

      ${Media.lg`
        grid-area: ${props => ` ${props.theme.main.gridArea.lg} !important`};
        margin: ${props => props.theme.main.margin.lg};
      `}

      ${Media.md`
        grid-area: ${props => ` ${props.theme.main.gridArea.md} !important`};
        margin: ${props => props.theme.main.margin.md};
      `}

      ${Media.sm`
      grid-area: ${props => ` ${props.theme.main.gridArea.sm} !important`};
        margin: ${props => props.theme.main.margin.sm};
      `}

      ${props =>
        props.theme.main.shape &&
        css`
          .shape {
            position: absolute;
            display: inline-flex;
            top: 0;
            left: 0;
            right: 0;
            bottom: -55px;

            ${Media.lg`
            display: none;
          `}

            div {
              width: 100%;
              height: 100%;
            }

            svg {
              width: 100%;
              height: 100%;

              path {
                fill: ${props => props.theme.main.shapeBackground};
              }
            }
          }
        `}
        ${props =>
          props.reverted &&
          css`
          grid-area: ${props =>
            ` ${props.theme.main.gridAreaReverted.default} !important`};
          ${Media.lg`
            grid-area: ${props =>
              ` ${props.theme.main.gridAreaReverted.lg} !important`};
          `}

          ${Media.md`
            grid-area: ${props =>
              ` ${props.theme.main.gridAreaReverted.md} !important`};
          `}

          ${Media.sm`
          grid-area: ${props =>
            ` ${props.theme.main.gridAreaReverted.sm} !important`};
          `}
            `}
    `}
`;

export const ItemExternal = styled.a`
  position: relative;
  display: grid;
  align-items: flex-start;
  grid-template-columns: ${props => props.theme.gridColumns.default};
  grid-template-rows: auto 1fr;
  grid-gap: ${props => props.theme.gridGap};
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};
  border-radius: ${props => props.theme.borderRadius.default};
  border-top: ${props => props.theme.border.top};
  border-right: ${props => props.theme.border.right};
  border-bottom: ${props => props.theme.border.bottom};
  border-left: ${props => props.theme.border.left};
  box-shadow: ${props => props.theme.boxShadow};
  transition: 0.2s all;
  cursor: pointer;
  &:hover ${Link} {
    background-color: ${props => props.theme.backgroundColorOnHoverLink};
  }
  ${Media.lg`
    grid-template-columns: ${props => props.theme.gridColumns.lg};
    margin: ${props => props.theme.margin.lg};
    padding: ${props => props.theme.padding.lg};
  `}

  ${Media.md`
    grid-template-columns: ${props => props.theme.gridColumns.md};
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};
  `}

  ${Media.sm`
    grid-template-columns: ${props => props.theme.gridColumns.sm};
    margin: ${props => props.theme.margin.sm};
    padding: ${props => props.theme.padding.sm};
  `}


  ${ItemHolder}:last-of-type & {
    border-bottom: ${props => props.theme.border.lastOfType.bottom};
  }
`;

export const Item = styled(RouterLink)`
  position: relative;
  display: grid;
  align-items: flex-start;
  align-content: flex-start;
  height: ${props => props.theme.height};
  grid-template-columns: ${props => props.theme.gridColumns.default};
  grid-gap: ${props => props.theme.gridGap};
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  color: ${props => props.theme.color || 'inherit'};
  background: ${props => props.theme.background};
  border-radius: ${props => props.theme.borderRadius.default};
  border-top: ${props => props.theme.border.top};
  border-right: ${props => props.theme.border.right};
  border-bottom: ${props => props.theme.border.bottom};
  border-left: ${props => props.theme.border.left};
  box-shadow: ${props => props.theme.boxShadow};
  transition: 0.2s all;
  cursor: pointer;
  &:hover ${Link} {
    background-color: ${props => props.theme.backgroundColorOnHoverLink};
  }
  ${Media.lg`
    grid-template-columns: ${props => props.theme.gridColumns.lg};
    margin: ${props => props.theme.margin.lg};
    padding: ${props => props.theme.padding.lg};
  `}

  ${Media.md`
    grid-template-columns: ${props => props.theme.gridColumns.md};
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
    border-radius: ${props => props.theme.borderRadius.md};
  `}

  ${Media.sm`
    grid-template-columns: ${props => props.theme.gridColumns.sm};
    margin: ${props => props.theme.margin.sm};
    padding: ${props => props.theme.padding.sm};
  `}

  ${props =>
    props.main &&
    css`
      grid-template-columns: ${props => props.theme.main.gridColumns.default};
      grid-template-rows: auto;
      grid-area: 1 / 1 / 2 / 5;
      align-content: space-between;
      margin: ${props => props.theme.main.margin.default};
      padding: ${props => props.theme.main.padding.default};
      background: ${props => props.theme.main.background};
      border-radius: ${props => props.theme.main.borderRadius.default};
      box-shadow: ${props => props.theme.main.boxShadow};
      &:hover ${Link} {
        background-color: ${props =>
          props.theme.backgroundColorOnHoverLinkMain};
        color: ${props => props.theme.colorOnHoverLinkMain};
      }
      ${Media.lg`
        grid-template-columns: ${props => props.theme.main.gridColumns.lg};
        grid-area: 1 / 1 / 2 / 3;
        margin: ${props => props.theme.main.margin.lg};
        padding: ${props => props.theme.main.padding.lg};
      `}

      ${Media.md`
        grid-template-columns: ${props => props.theme.main.gridColumns.md};
        grid-area: 1 / 1 / 2 / 3;
        margin: ${props => props.theme.main.margin.md};
        padding: ${props => props.theme.main.padding.md};
        border-radius: ${props => props.theme.main.borderRadius.md};
      `}

      ${Media.sm`
        grid-template-columns: ${props => props.theme.main.gridColumns.sm};
        grid-area: 1 / 1 / 2 / 3;
        margin: ${props => props.theme.main.margin.sm};
        padding: ${props => props.theme.main.padding.sm};
      `}
    `}

`;

export const Imagebox = styled.picture`
  position: relative;
  display: block;
  align-self: flex-end;
  max-width: ${props => props.theme.maxWidth};
  height: ${props => props.theme.height};
  margin: ${props => props.theme.margin.default};

  ${Media.lg`
    margin: ${props => props.theme.margin.lg};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
  `}

  ${Media.sm`
    margin: ${props => props.theme.margin.sm};
  `}

  ${props =>
    props.main &&
    css`
      max-width: ${props => props.theme.main.maxWidth};
      margin: ${props => props.theme.main.margin.default};
      order:  ${props => props.theme.order || '0'};

      ${Media.lg`
        margin: ${props => props.theme.main.margin.lg};
      `}

      ${Media.md`
        margin: ${props => props.theme.main.margin.md};
      `}

      ${Media.sm`
        margin: ${props => props.theme.main.margin.sm};
      `}

  `}

  ${props =>
    props.theme.triangleShape &&
    css`
      &::after {
        position: absolute;
        top: ${props.theme.triangleShape.top};
        right: ${props.theme.triangleShape.right};
        bottom: ${props.theme.triangleShape.bottom};
        left: ${props.theme.triangleShape.left};
        display: ${props.theme.triangleShape.display.default};
        width: ${props.theme.triangleShape.width};
        height: ${props.theme.triangleShape.height};
        transition: 0.2s all;
        clip-path: ${props.theme.triangleShape.clipPath};
        background: ${props.theme.triangleShape.background};
        content: '';

        ${Media.lg`
          display: ${props.theme.triangleShape.display.lg};
        `}

        ${Media.md`
          display: ${props.theme.triangleShape.display.md};
        `}

        ${Media.sm`
          display: ${props.theme.triangleShape.display.sm};
        `}
      }
    `}
`;

export const Source = styled.source``;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${props => props.theme.borderRadius.default};

  ${Media.md`
    border-radius: ${props => props.theme.borderRadius.md};
  `}
`;

export const Featured = styled.span`
  position: absolute;
  top: ${props => props.theme.top.default};
  bottom: ${props => props.theme.bottom.default};
  right: ${props => props.theme.right};
  left: ${props => props.theme.left};
  bottom: ${props => props.theme.bottom};
  font-family: ${props => props.theme.fontFamily || 'inherit'};
  display: flex;
  align-items: center;
  justify-content: ${props => props.theme.justifyContent};
  transform: ${props => props.theme.transform};
  min-width: ${props => props.theme.minWidth.default};
  min-height: ${props => props.theme.minHeight.default};
  padding: ${props => props.theme.padding};
  border-radius: ${props => props.theme.borderRadius.default};
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  box-shadow: ${props => props.theme.boxShadow};
  z-index: 2;

  ${props =>
    !props.theme.shape &&
    css`
      background: ${props => props.theme.background};
    `}

  ${Media.lg`
    min-width: ${props => props.theme.minWidth.lg};
    min-height: ${props => props.theme.minHeight.lg};
    top: ${props => props.theme.top.lg};
    bottom: ${props => props.theme.bottom.lg};
    font-size: ${props => `${props.theme.fontSize.lg}rem`} !important;
    transform: translate(0, 0);
  `}

  ${Media.md`
    min-width: ${props => props.theme.minWidth.md};
    min-height: ${props => props.theme.minHeight.md};
    top: ${props => props.theme.top.md};
    bottom: ${props => props.theme.bottom.md};
    border-radius: ${props => props.theme.borderRadius.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`} !important;
  `}

  ${Media.sm`
    min-width: ${props => props.theme.minWidth.sm};
    min-height: ${props => props.theme.minHeight.sm};
    top: ${props => props.theme.top.sm};
    bottom: ${props => props.theme.bottom.sm};
    font-size: ${props => `${props.theme.fontSize.sm}rem`} !important;
  `}

  ${props =>
    props.main &&
    css`
      font-size: ${props.theme.main.fontSize.default}rem !important;
      left: ${props => props.theme.main.left};
      top: ${props => props.theme.main.top.default};
      bottom: ${props => props.theme.main.bottom.default};
      padding: ${props => props.theme.main.padding};

      ${Media.lg`
        min-width: ${props => props.theme.main.minWidth.lg};
        min-height: ${props => props.theme.main.minHeight.lg};
        font-size: ${props => `${props.theme.main.fontSize.lg}rem !important`};
        transform: translate(0, 0);
      `}

      ${Media.md`
        min-width: ${props => props.theme.main.minWidth.md};
        min-height: ${props => props.theme.main.minHeight.md};
        border-radius: ${props => props.theme.main.borderRadius.md};
        font-size: ${props => `${props.theme.main.fontSize.md}rem !important`};
      `}

      ${Media.sm`
        min-width: ${props => props.theme.main.minWidth.sm};
        min-height: ${props => props.theme.main.minHeight.sm};
        font-size: ${props => `${props.theme.main.fontSize.sm}rem !important`};
      `}
  `};

  ${props =>
    props.theme.shape &&
    css`
      .shape {
        position: absolute;
        display: inline-flex;
        top: 50%;
        left: 50%;
        width: ${props => props.theme.minWidth.default};
        height: ${props => props.theme.minHeight.default};
        transform: translate(-50%, -50%);

        ${Media.lg`
          width: ${props => props.theme.minWidth.lg};
          height: ${props => props.theme.minHeight.lg};
        `}

        ${Media.md`
          width: ${props => props.theme.minWidth.md};
          height: ${props => props.theme.minHeight.md};
        `}

        ${Media.sm`
          width: ${props => props.theme.minWidth.sm};
          height: ${props => props.theme.minHeight.sm};
        `}

        svg {
          width: 100%;
          height: 100%;
          path {
            fill: ${props => props.theme.background};
          }
        }
      }
    `}
`;

export const Star = styled.i`
  position: ${props => props.theme.position || 'relative'};
  top: ${props => props.theme.top};
  left: ${props => props.theme.left};
  right: ${props => props.theme.right};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.theme.width};
  height: ${props => props.theme.height};
  margin: ${props => props.theme.margin};
  transform: ${props => props.theme.transform};
  border-radius: ${props => props.theme.borderRadius};
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  vertical-align: middle;

  svg {
    font-size: ${props => `${props.theme.fontSize.default}em`};

    ${Media.lg`
      font-size: ${props => `${props.theme.fontSize.lg}em`};
    `}

    ${Media.md`
      font-size: ${props => `${props.theme.fontSize.md}em`};
    `}

    ${Media.sm`
      font-size: ${props => `${props.theme.fontSize.sm}em`};
    `}
  }

  ${props =>
    props.main &&
    css`
      width: ${props => `${props.theme.main.width}`};
      height: ${props => `${props.theme.main.height}`};
      margin: ${props => props.theme.main.margin};
      color: ${props => props.theme.main.color};

    svg {
      font-size: ${props => `${props.theme.main.fontSize.default}em`};

      ${Media.lg`
        font-size: ${props => `${props.theme.main.fontSize.lg}em`};
      `}

      ${Media.md`
        font-size: ${props => `${props.theme.main.fontSize.md}em`};
      `}

      ${Media.sm`
        font-size: ${props => `${props.theme.main.fontSize.sm}em`};
      `}
    }

  `}
`;

export const Details = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: ${props => props.theme.height};
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  align-items: ${props => props.theme.alignItems};

  ${Media.lg`
    margin: ${props => props.theme.margin.lg};
    padding: ${props => props.theme.padding.lg};
  `};

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    padding: ${props => props.theme.padding.md};
  `}

  ${Media.sm`
    margin: ${props => props.theme.margin.sm};
    padding: ${props => props.theme.padding.sm};
  `}

  ${props =>
    props.main &&
    css`
      color: ${props => props.theme.main.color || 'inherit'};
      margin: ${props => props.theme.main.margin.default};
      justify-content: flex-start;
      min-height: 150px;
      padding: ${props => props.theme.main.padding.default};

      ${Media.lg`
        margin: ${props => props.theme.main.margin.lg};
        padding: ${props => props.theme.main.padding.lg};
        min-height: 1px;
      `}

      ${Media.md`
        margin: ${props => props.theme.main.margin.md};
        padding: ${props => props.theme.main.padding.md};
      `}

      ${Media.sm`
        margin: ${props => props.theme.main.margin.sm};
        padding: ${props => props.theme.main.padding.sm};
      `}
  `}

  ${props =>
    props.theme.triangleShape &&
    css`
      &::after {
        position: absolute;
        top: ${props.theme.triangleShape.top};
        right: ${props.theme.triangleShape.right};
        bottom: ${props.theme.triangleShape.bottom};
        left: ${props.theme.triangleShape.left};
        display: ${props.theme.triangleShape.display.default};
        width: ${props.theme.triangleShape.width};
        height: ${props.theme.triangleShape.height};
        transition: 0.2s all;
        clip-path: ${props.theme.triangleShape.clipPath};
        background: ${props.theme.triangleShape.background};
        content: '';

        ${Media.lg`
          display: ${props.theme.triangleShape.display.lg};
        `}

        ${Media.md`
          display: ${props.theme.triangleShape.display.md};
        `}

        ${Media.sm`
          display: ${props.theme.triangleShape.display.sm};
        `}
      }
    `}
`;

export const Title1 = styled.h2`
  display: block;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  word-break: ${props => props.theme.wordBreak};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  ${props =>
    props.main &&
    css`
      color: ${props => props.theme.main.color || props.theme.color};
      font-size: ${props => `${props.theme.main.fontSize.default}rem`};
      ${Media.lg`
        font-size: ${props => `${props.theme.main.fontSize.lg}rem`};
      `}

      ${Media.md`
        font-size: ${props => `${props.theme.main.fontSize.md}rem`};
      `}

      ${Media.sm`
        font-size: ${props => `${props.theme.main.fontSize.sm}rem`};
      `}
    `}
`;

export const Text = styled.p`
  display: block;
  max-width: 100%;
  width: 100%;
  margin: ${props => props.theme.margin.default};
  transition: 0.2s all;
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    margin: ${props => props.theme.margin.md};
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}
`;

export const Arrow = styled.i`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${props => props.theme.minWidth};
  min-height: ${props => props.theme.minHeight};
  margin: 0 0 0 5px;
  background: ${props => props.theme.background};
  color: ${props => props.theme.color};
  vertical-align: middle;
  border-radius: ${props => props.theme.borderRadius.default};
  transition: 0.2s all;

  ${Media.md`
    border-radius: ${props => props.theme.borderRadius.md};
  `}

  ${props =>
    props.main &&
    css`
      display: ${props.theme.main.display};
      color: ${props => `${props.theme.main.color}`} !important;
    `};

  ${props =>
    props.theme.invert &&
    css`
      background: ${props => props.theme.color};
      color: ${props => props.theme.background};
    `}

  ${Link}:hover & {
    background: ${props => props.theme.backgroundOnHover};
    color: ${props => props.theme.colorOnHover};

    ${props =>
      props.theme.invert &&
      css`
        background: ${props => props.theme.colorOnHover};
        color: ${props => props.theme.backgroundOnHover};
      `}
  }
`;
export const MoreLink = styled(RouterLink)`
  align-self: flex-end;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  border-radius: ${props => props.theme.borderRadius.default};
  ${props =>
    props.theme.background &&
    css`
      background: ${props => props.linkBackground || props.theme.background};
    `}
  ${props =>
    props.theme.color &&
    css`
      color: ${props => props.linkColor || props.theme.color};
    `}
  transition: 0.2s all;
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  white-space: nowrap;
  z-index: 0;
  cursor: pointer;
`;
